define('nls/messages',{
    'root': true
});
